import { Component } from '@opten/compiler/metadata/component';
import { queryStringAsObject } from '@opten/url/query-string-as-object';

@Component({ className: 'js-form-extended' })
export class FormExtended {
	constructor() {
		const params = queryStringAsObject(window.location.toString());
		const disableOnSet = true;
		for (const param in params) {
			if (param) {
				const el = document.querySelector(`[data-alias="${param}"]`) as HTMLInputElement;
				if (el) {
					el.value = params[param];
					el.disabled = true;
				}
			}
		}
	}
}
